module.exports = __webpack_public_path__ + "7000d80b361a48f119211db31885e8aa.svg";